
var template = require('./slide.ejs');
require('./slide.css');
var win = window;
        var LiveSlide = function(options){

            this.init(options);
           };

            // 创建组件内部数据
            LiveSlide.prototype.init = function (options) {
                this.options = options;
                this.src = '';
                this.srcServeUrl = '//d.ifengimg.com';
                this.srcRatio = 'mw950';
                this.maxW = 950;
                this.padding = 50;
                this.isHide = true;
                this.isLoading = false;
                this.resolveTemplate(options);
                this.renderer();
                this.bindDomEvent();
                this.hide();

            };

            // 创建并解析模板
            LiveSlide.prototype.resolveTemplate = function (options) {
                this.el = $(template(options));
                this.imgBox = this.el.find('.js_imgBox');
                this.el.hide();
            };

            // 绑定dom事件
            LiveSlide.prototype.bindDomEvent = function () {
                var resizeTimer = null;
                var _this = this;
                //this.el.on('click', $.proxy(this.hide, this));
                // if(len>1){ //8月22需求，只一张图时，不允许有左右翻页按钮
                //     console.log("dayu1");
                //     this.imgBox.on('click', 'img', $.proxy(this.change, this));
                //     this.imgBox.on('mousemove', 'img', $.proxy(this.cursor, this));
                // }
                this.imgBox.on('click', 'img', $.proxy(this.change, this));
                this.imgBox.on('mousemove', 'img', $.proxy(this.cursor, this));

                $(win).on('resize', function () {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        _this.resize();
                    }, 100);
                });
            };

            // 渲染组件。
            LiveSlide.prototype.renderer = function () {
                $('body').append(this.el);

            };


            LiveSlide.prototype.show =  function (pics, index) {
                if (typeof pics == 'string') {
                    pics = [pics];
                }
                this.total = pics.length;
                this.index = typeof index == 'undefined' ? 0 : index;
                this.pics = pics;

                if (this.isHide === false) {
                    return;
                }

                this.isHide = false;
                this.el.fadeIn();
                this.hideHtmlScroll();
                //this.mask.show();
                if (typeof pics !== 'undefined') {
                    this.update(this.pics[this.index]);
                } else {
                    this.resize();
                }

            };

            LiveSlide.prototype.hide = function () {
                var _this = this;

                if (this.isHide === true) {
                    return;
                }

                this.isHide = true;
                this.el.fadeOut(function () {
                    _this.restoreHtmlScroll();
                });

            };

            LiveSlide.prototype.update =  function (src) {
                var _this = this;
                var img = new Image();
                if (src.w/1 <= this.maxW) {
                    this.imgWidth = src.w / 1 + this.padding;
                    this.imgHeight = src.h / 1 + this.padding;
                } else {
                    this.imgWidth = this.maxW / 1 + this.padding;
                    this.imgHeight = this.maxW * src.h / src.w + this.padding;
                }
                img.width = this.imgWidth - this.padding;
                img.height = this.imgHeight - this.padding;
                this.resize();
                if(this.total>1){ //8月22需求，只一张图时，不允许有页码
                    this.imgBox.html('<div class="w-page">' + (this.index + 1) + '<span> / ' + this.total + '</span></div>');
                }else{
                    this.imgBox.html('');
                }
                this.imgBox.append(img);
                img.src = this.getSrc(src.url);
            };

            LiveSlide.prototype.cursor = function (e) {
                if(this.total>1){
                    var x = e.offsetX;
                    if (x < this.imgWidth / 2) {
                        this.imgBox.find('img').addClass('left').removeClass('right');
                    } else {
                        this.imgBox.find('img').addClass('right').removeClass('left');
                    }
                }

            };

            LiveSlide.prototype.change = function (e) {
                if (this.isLoading || this.total == 1) {
                    return false;
                }

                var x = e.offsetX;
                if (x < this.imgWidth / 2) {
                    this.pre();
                } else {
                    this.next();
                }
                return false;
            };

            LiveSlide.prototype.pre = function () {
                if (this.index > 0 ) {
                    this.index = this.index - 1;
                } else {
                    this.index = this.total - 1;
                }

                this.update(this.pics[this.index]);
            };

            LiveSlide.prototype.next = function () {

                if (this.index < this.total - 1) {
                    this.index = this.index + 1;
                } else {
                    this.index = 0;
                }

                this.update(this.pics[this.index]);
            };

            LiveSlide.prototype.getSrc = function (src) {
                var srcRatio = this.srcRatio.lastIndexOf('/') === 0 ?
                    this.srcRatio : this.srcRatio + '/';
                var srcServeUrl = this.srcServeUrl.lastIndexOf('/') === 0 ?
                    this.srcServeUrl : this.srcServeUrl + '/';
                src = src.replace('http://', '');
                return srcServeUrl + srcRatio + src;
            };

            LiveSlide.prototype.resize = function () {

                if (this.isHide) {
                    return;
                }

                var boxTop;
                var winHeight = $(win).height();
                var winWidth = $(win).width();
                this.el.height(winHeight);

                if (this.imgHeight > winHeight - 100) {
                    boxTop = 50;
                } else {
                    boxTop = (winHeight - this.imgHeight) / 2;
                }

                var boxLeft = (winWidth - this.imgWidth) / 2;
                this.imgBox.css('top', boxTop + 'px');
                this.imgBox.css('left', boxLeft + 'px');
                //this.mask.resize();
            };

            LiveSlide.prototype.hideHtmlScroll = function () {
                $('html').css('overflow', 'hidden');

                // if (!($.browser.msie && $.browser.version === '6.0')) {
                //     $('html').css('padding-right', '17px');
                // }

            };

            LiveSlide.prototype.restoreHtmlScroll = function () {
                $('html').css('overflow', '');

                // if (!($.browser.msie && $.browser.version === '6.0')) {
                //     $('html').css('padding-right', '');
                // }

            };


module.exports = LiveSlide;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pic.pc/app/modules/slide/index.js